import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    customFieldsMarker: {
      color: legacyColors.red,
      whiteSpace: 'pre-wrap',
    },
  };
};
